export default "__VITE_ASSET__CuHJ_tlj__"